/* Stylesheet */

.item_sliding_options {
  .item_sliding {
    --padding-start: 32px;
    --background-activated: #f3f5f7;
    --ripple-color: transparent;
    font-size: 0.938rem;
  }
}
